var moduleMap = {
	"./user": function() {
		return Promise.all([__webpack_require__.e(912), __webpack_require__.e(795), __webpack_require__.e(547), __webpack_require__.e(606)]).then(function() { return function() { return (__webpack_require__(8834)); }; });
	},
	"./department": function() {
		return Promise.all([__webpack_require__.e(912), __webpack_require__.e(870)]).then(function() { return function() { return (__webpack_require__(2870)); }; });
	},
	"./message": function() {
		return Promise.all([__webpack_require__.e(912), __webpack_require__.e(218)]).then(function() { return function() { return (__webpack_require__(6218)); }; });
	},
	"./roster": function() {
		return Promise.all([__webpack_require__.e(912), __webpack_require__.e(795), __webpack_require__.e(865)]).then(function() { return function() { return (__webpack_require__(9296)); }; });
	},
	"./addresslist": function() {
		return Promise.all([__webpack_require__.e(912), __webpack_require__.e(795), __webpack_require__.e(547), __webpack_require__.e(702)]).then(function() { return function() { return (__webpack_require__(1450)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});